module.exports = __webpack_public_path__ + "images/business-class-logo-blue.3494275fd68fd1b05677.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/business-class-logo-blue.svg
// module id = YoNf
// module chunks = 1